import React, { useState, useEffect } from "react";
// import styles from "../../components/CustomerList/CustomerList.module.scss";
import styles from "./DocumentUpload.module.scss";
import axios from "axios";
import FormButtons from "../../components/InformationsForms/FormButtons";
import { baseUrl } from "../../common/constants";
import { toast } from "react-toastify";
import RenderFilesComponent from "../../components/CustomerList/RenderFilesComponent";
import _axios from "../../utils/api/_axios";
import { Button, Col, Row } from "antd";
import { CloudUploadOutlined } from "@ant-design/icons";
import { Content } from "antd/es/layout/layout";

// TODO ROHIT: DOCUMENT FORM 
const DocumentUploadForm = ({ handleClose, patientId, claimId="", claim={}, isForm=true}) => {
  const [files, setFiles] = useState([]);
  const [fetchedFiles, setFetchedFiles] = useState([]);
  const [isEditing, setIsEditing] = useState(isForm);
  const [isFilesSelected, setIsFilesSelected] = useState(false);
  // const [selectedFile, setSelectedFile] = useState(null);
  const [noReports, setNoReports] = useState(false);
  let selectedFiles = [];
  let ClaimId;

  const handleFile = (e) => {
    const fileList = e.target.files || e.dataTransfer.files;
    if (fileList.length > 0) {
      const allowedExtensions = [
        ".pdf",
        ".doc",
        ".docx",
        ".jpg",
        ".jpeg",
        ".png",
      ];

      Array.from(fileList).forEach((file) => {
        const fileExtension = file.name.split(".").pop();
        if (
          allowedExtensions.includes(`.${fileExtension.toLowerCase()}`) &&
          file.size <= 10 * 1024 * 1024 // 10 MB
        ) {
          selectedFiles.push(file);
        }
      });

      if (selectedFiles.length === 0) {
        toast.error("No valid files selected. Please choose valid files.");
        return;
      }

      setFiles((prevFiles) => [...prevFiles, ...selectedFiles]);
      setIsFilesSelected(true);
      console.log("selectedFiles",selectedFiles);
      console.log("Files",files);
    }
  };
  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const formData = new FormData();
      files.forEach((file) => {
        formData.append("file", file);
      });
      // const url = `${baseUrl}/patients/${patientId}/upload/documents`;
      // const response = await _axios.post(url, formData, {
      //   headers: { "Content-Type": "multipart/form-data" },
      // });
      resetForm();
      // if (response.status === 201) {
      //   toast.success("Successfully Uploaded reports.");
      //   handleClose(true, patientId, ClaimId);
      // } else {
      //   toast.error("Upload Failed.");
      //   handleClose(false);
      // }
    } catch (error) {
      if (error.response && error.response.status === 409) {
        toast.error("Duplicate reports. Please upload unique reports.");
      } else {
        console.error("Error:", error);
      }
    }
  };

  const handleDelete = async (file) => {
    if (patientId) {
      try {
        if (!file || !file._id) {
          toast.error('Invalid file data.');
          return;
        }

        // const deleteUrl = `${baseUrl}/patients/media/${patientId}/documents/${file._id}`;
        
        // const updatedFiles = fetchedFiles.filter((f) => f !== file);
        // setFetchedFiles(updatedFiles);

        // await _axios.delete(deleteUrl);

        toast.success(`File ${file.name} deleted successfully.`);
      } catch (error) {
        setFetchedFiles((prevFiles) => [...prevFiles, file]);

        if (error.response && error.response.status === 404) {
          toast.error('File not found.');
        } else {
          toast.error('Error deleting file.');
        }
      }
    }
  };

  const resetForm = () => {
    setFiles([]);
    setIsFilesSelected(false);
  };

  const handleButtonClick = () => {
    document.getElementById('fileInput').click();
  };

  let fetchInitial = async (patientId) => {
    if (patientId) {
      try {
        let res = await _axios.get(
          `${baseUrl}/patients/media/${patientId}/documents`,
          // `${baseUrl}/media/document?patientId=${patientId}`,
          {
            params: {
              title: "docs",
            },
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        return res.data.payload;
      } catch (err) {
        toast.error(err.message);
      }
    }
  };

  useEffect(() => {
    fetchInitial(patientId)
    .then((payload) => {
      if (payload) {
          setFetchedFiles(payload);
        }
      })
      .catch((error) => {
        toast.error("Error:", error);
      });
  }, [patientId]);

  return (
      <Content>
        <form 
         onSubmit={handleSubmit}
        >
        <div className={styles.header}>
          <h4>Documents</h4>
          <div className={styles.clear}></div>
        </div>
        <div className={styles.formContainerBorder}>
          <div className={styles.formContainer}>
              <>
                <div className={styles.uploadedReports}>
                  <RenderFilesComponent fetchedFiles={fetchedFiles} isDocument={true} onDeleteFile={handleDelete} />
                </div>
                <br></br>
                  <Row gutter={16} className={styles.gridContainer}>
                      <Col xs={18}>
                          <Button
                            onClick={handleButtonClick}
                            fullWidth
                            variant="outlined"
                          >
                              {isFilesSelected ? (
                                  <span>Selected Documents: {files.map((file) => file.name).join(", ")}</span>
                              ) : (
                                  <span>Select Documents</span>
                              )}
                          </Button>
                          <input
                          type="file"
                          key={isFilesSelected ? "selected" : "unselected"}
                          id="fileInput"
                          accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                          className={styles.fileInput}
                          multiple
                          onChange={handleFile}
                          />
                      </Col>
                      <Col xs={6}>
                          <Button type="primary" component="label" onClick={handleSubmit} variant="outlined" fullWidth icon={<CloudUploadOutlined />}>
                              Upload
                          </Button>
                      </Col>
                  </Row>
                <div className={styles.formButtonsContainer}>
                  <Row gutter={16} className={'display-flex-justify-end'} >
                  <Col xs={12}></Col>
                  <Col xs={12}>
                      <Button className={`button ${styles.buttonCancel}`} onClick={handleClose} fullWidth>
                        Close
                      </Button>
                  </Col>
                </Row>
                </div>
            </>
      </div>
    </div>
      </form>
    </Content>
  );
};

export default DocumentUploadForm;